<template>
  <div class="personal-details">
    <div class="header">
      <h2>Uw gegevens</h2>
      <p>
        Heeft u al een {{ blogName }} account? 
        <button class="login-button" @click="SET_LOGIN(true)">Log dan eerst in.</button>
      </p>
    </div>
    <div class="personal-details-grid">
      <personal-details-form :namespace="namespace" />
      <div>
        <express-checkout-cart :namespace="namespace" />
      </div>
    </div>
  </div>
</template>

<script>

  import { mapState, createNamespacedHelpers } from 'vuex'
  import PersonalDetailsForm from './PersonalDetailsForm'
  import ExpressCheckoutCart from './ExpressCheckoutCart'

  export default {
    components: {
      PersonalDetailsForm,
      ExpressCheckoutCart
    },
    props: {
      namespace: {
        type: String,
        required: true
      }
    },
    computed: {
      ...mapState({
        blogName: state => state.expressCheckoutSettings.blogName
      })
    },
    beforeCreate () {
      const namespace = this.$options.propsData.namespace
      const { mapMutations } = createNamespacedHelpers(namespace)
      // methods
      this.$options.methods = {
        ...(this.$options.methods || {}),
        ...mapMutations(['SET_LOGIN'])
      }
    },
  }
</script>

<style lang="scss" scoped>

  @import '../assets/styles/_variables.scss';
  @import '../assets/styles/_mixins.scss';

  .personal-details {
    width: 100%;
    margin: 0 auto;
    padding: 0 1.5em 5em 1.5em;

    @include screen(md) {
      width: 8 / 10 * 100%;
      padding: 0 0 3em 0;
    }

  }

  .header {
    text-align: center;
    padding-bottom: 1.5em;

    @include screen(md) {
      padding-bottom: 2.5em;
    }
    
    h2 {
      font-size: 1.5em;
      line-height: 1.33;
      margin-bottom: .5em;

      @include screen(md) {
        font-size: 1.75em;
        line-height: 1.2;
      }

    }

    p {
      color: var(--ec-gray, lighten(black, 35));
    }

  }

  .personal-details-grid {
    display: grid;
    grid-template-columns: 1fr;
    grid-column-gap: 2em;
    grid-row-gap: .5em;

    @include screen(md) {
      grid-template-columns: 5fr 3fr;
    }
  }

  .login-button {
    display: inline;
    background: transparent;
    border: none;
    padding: 0;
    cursor: pointer;
    text-decoration: underline;
    color: var(--ec-primary-color, black);
  }

</style>